import { useBem } from '@musica-sacra/hooks';

type SidebarExpandButtonProps = {
    onClickCallback: () => void;
};

export function SidebarExpandButton({
    onClickCallback,
}: SidebarExpandButtonProps) {
    const { bem } = useBem('ms-sidebar-expand-button');

    return (
        <div className={bem()}>
            <button onClick={onClickCallback} aria-label="Sidebar">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    enableBackground="new 0 0 24 24"
                    height="24px"
                    viewBox="0 0 24 24"
                    width="24px"
                    fill="currentColor"
                >
                    <g>
                        <rect fill="none" height="24" width="24" />
                        <rect fill="none" height="24" width="24" />
                    </g>
                    <g>
                        <g>
                            <path d="M5.7,6.71L5.7,6.71c-0.39,0.39-0.39,1.02,0,1.41L9.58,12L5.7,15.88c-0.39,0.39-0.39,1.02,0,1.41l0,0 c0.39,0.39,1.02,0.39,1.41,0l4.59-4.59c0.39-0.39,0.39-1.02,0-1.41L7.12,6.71C6.73,6.32,6.09,6.32,5.7,6.71z" />
                            <path d="M12.29,6.71L12.29,6.71c-0.39,0.39-0.39,1.02,0,1.41L16.17,12l-3.88,3.88c-0.39,0.39-0.39,1.02,0,1.41l0,0 c0.39,0.39,1.02,0.39,1.41,0l4.59-4.59c0.39-0.39,0.39-1.02,0-1.41l-4.59-4.59C13.32,6.32,12.68,6.32,12.29,6.71z" />
                        </g>
                    </g>
                </svg>
            </button>
        </div>
    );
}
